module.exports = __webpack_public_path__ + "static/media/general.1ae5f66.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/general.mp4
// module id = GMvz
// module chunks = 1